import React from 'react';
import styled from 'styled-components';
import { MuiThemeProvider } from 'material-ui/styles';
import { I18n } from 'react-i18next';

import theme from '../../theme';

import Googlemap from './Googlemap';

const Container = styled.div`
  height: 100vh;
  background-size: cover;
`;

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      isHidden: true,
      btnlangfr: true,
      btnlangen: true,
    };
  }

  toggleHidden() {
    this.setState({
      isHidden: !this.state.isHidden,
    });
  }
  componentDidMount() {
    window.document.title = this.props.route.title;

    let langu = localStorage.getItem('i18nextLng');
    if (langu === 'fr-FR' || langu === 'fr') {
      this.setState({ btnlangfr: false });
    } else if (langu === 'en-US' || langu === 'en') {
      this.setState({ btnlangen: false });
    }
  }

  componentDidUpdate() {
    window.document.title = this.props.route.title;
  }

  clicklgfr = () => {
    this.setState({ btnlangfr: false });
    this.setState({ btnlangen: true });
  };

  clicklgen = () => {
    this.setState({ btnlangen: false });
    this.setState({ btnlangfr: true });
  };
   goClose=()=> {
    var divsToHide = document.getElementsByClassName('hidelist');
    for (var Hide = 0; Hide < divsToHide.length; Hide++) {
      divsToHide[Hide].style.display = 'none';
    }
  
    document.getElementById('textheade').classList.remove('hidden');
    document.getElementById('clsicon').classList.add('hidden');
    document.getElementById('plsicon').classList.remove('hidden');
  }
  render() {
    return (
      <I18n ns={['translations']}>
        {(t, { i18n }) => (
          <MuiThemeProvider theme={theme}>
            <Container>
              {this.props.route.body}
              <Googlemap />
              <div className="langchang">
                <span
                  className={this.state.btnlangfr ? 'btnlang' : 'btnlangactive'}
                  onClick={() => {
                    this.goClose();
                    i18n.changeLanguage('fr');
                    this.setState({ btnlangfr: false });
                    this.setState({ btnlangen: true });
                  }}
                >
                  FR
                </span>

                <span
                  className={this.state.btnlangen ? 'btnlang' : 'btnlangactive'}
                  onClick={() => {
                    this.goClose();
                    i18n.changeLanguage('en');
                    this.setState({ btnlangen: false });
                    this.setState({ btnlangfr: true });
                  }}
                >
                  EN
                </span>
              </div>
              <img
                src="../assets/images/lacroix_small.png"
                width="100"
                className={'logopot'}
                alt=""
              />
            </Container>
          </MuiThemeProvider>
        )}
      </I18n>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js